import { Attribute, AttributeOption } from '@mark43/cad-api';

export function toAttributeOption(
    attribute: Attribute,
    options?: { includeDisplayAbbreviation: boolean }
): AttributeOption {
    return {
        isOther: attribute.isOther,
        value: attribute.id,
        label: options?.includeDisplayAbbreviation
            ? `${attribute.displayAbbreviation} - ${attribute.displayValue}`
            : attribute.displayValue || '',
        parentAttributeId: attribute.parentAttributeId,
    };
}
